import ReactDOM from 'react-dom';
import $ from 'jquery';
import React from 'react';
import { getMapboxgl } from '../../services/mapboxService';
import { convertStateToColor, getIconUrl } from '../../services/mapService';

const mapIns = getMapboxgl();
const mapboxgl = mapIns.mapboxgl;

const LabelContainer = ({ labelText }) => <span className="location-label">{labelText}</span>;

const IconMarker = props => {
  const { title, labelText, className, url, backgroundColor } = props.config;
  const style = {
    ...(url ? {} : { background: backgroundColor }),
  };
  return (
    <div className={className} data-title={title} {...(labelText && { 'data-label': labelText })} style={style}>
      {labelText && <LabelContainer labelText={labelText} />}
    </div>
  );
};

const IconVehicleMarker = props => {
  const { vehicle, vehicleNumber } = props.config;
  const style = {
    backgroundImage: `url("${getIconUrl(vehicle)}")`,
  };
  return (
    <div
      className={`vehicle-marker vehicle-${vehicleNumber}`}
      {...(vehicleNumber && { 'data-title': vehicleNumber })}
      style={style}
    />
  );
};

const createMarkerContainer = Marker => {
  const markerContainer = document.createElement('div');
  ReactDOM.render(Marker, markerContainer);
  return markerContainer;
};

const createPopup = config => {
  const { marker, content, clickOnClose, isCloseBtn } = config;

  const popup = new mapboxgl.Popup({ closeOnClick: clickOnClose, closeButton: isCloseBtn })
    .setHTML(content)
    .addTo(mapIns.mapbox);

  marker.setPopup(popup);
};

const createPositionMarker = markerInfo => {
  const lat = markerInfo.lat;
  const lng = markerInfo.lng;

  const colors = convertStateToColor(markerInfo.status);
  const config = {
    url: null,
    backgroundColor: colors[0],
    lat: lat,
    lng: lng,
    className: 'position-marker',
    title: markerInfo.title,
  };

  const newMarker = createIconMarker(config);
  newMarker.rideId = markerInfo.rideId;
  return newMarker;
};

const createLocationMarker = markerInfo => {
  const { isPickupLocation: isPickup, lat, lng, draggable = false } = markerInfo;
  const config = {
    title: `${isPickup ? 'Pickup' : 'Dropoff'} Location`,
    lat,
    lng,
    className: `location-marker location-${isPickup ? 'pickup' : 'dropoff'}`,
    draggable,
  };
  const newMarker = createIconMarker(config);
  // const popupConfig = {
  //   marker: newMarker,
  //   content: `${isPickup ? 'Pickup' : 'Dropoff'} Location`,
  //   clickOnClose: false,
  //   isCloseBtn: true
  // };
  // createPopup(popupConfig);
  return newMarker;
};

const createVehicleMarker = markerInfo => {
  const { vehicleNumber } = markerInfo;
  const newMarker = createIconVehicleMarker(markerInfo);
  // const popupConfig = {
  //   marker: newMarker,
  //   content: `<div class='vehicle-label'>${vehicleNumber}</div>`,
  //   clickOnClose: false,
  //   isCloseBtn: true
  // };
  // createPopup(popupConfig);
  return newMarker;
};

const createIconMarker = config => {
  const { lat, lng, draggable } = config;
  const markerContainer = createMarkerContainer(<IconMarker config={config} />);

  return new mapboxgl.Marker(markerContainer, {
    anchor: 'bottom',
    draggable: draggable,
  })
    .setLngLat([lng, lat])
    .addTo(mapIns.mapbox);
};

const createIconVehicleMarker = config => {
  const { lat, lng } = config;
  const markerContainer = createMarkerContainer(<IconVehicleMarker config={config} />);

  return new mapboxgl.Marker(markerContainer, {
    anchor: 'bottom',
  }).setLngLat([lng, lat]);
};

const hideMarker = marker => {
  marker.remove();
};

const hideLocationMarkers = () => {
  const locationMarkers = $('.location-marker');
  if (locationMarkers.length) {
    $.each(locationMarkers, function (key, marker) {
      marker.remove();
    });
  }
};

export { createPositionMarker, createLocationMarker, createVehicleMarker, hideMarker, hideLocationMarkers };
